if (!customElements.get('product-gallery')) {
  customElements.define(
    'product-gallery',
    class ProductGallery extends HTMLElement {
      constructor() {
        super();
        this._mobileSplide = null;
        this._mobileMql = window.matchMedia('(max-width: 749px)');
        this._onMobileMqlChange = () => this._syncMobileSplide();
      }

      connectedCallback() {
        this._bindMobileNav();
        this._bindMobileSplide();
        this._mobileMql.addEventListener('change', this._onMobileMqlChange);
      }

      _bindMobileNav() {
        const backBtn = this.querySelector('[data-gallery-back]');
        if (!backBtn || backBtn.dataset.bound === 'true') return;

        backBtn.dataset.bound = 'true';
        backBtn.addEventListener('click', () => {
          const fallback = backBtn.dataset.fallbackUrl;
          if (window.history.length > 1) {
            window.history.back();
            return;
          }
          if (fallback) window.location.assign(fallback);
        });
      }

      _updateMobileCounter(index) {
        const currentEl = this.querySelector('[data-gallery-current]');
        const totalEl = this.querySelector('[data-gallery-total]');
        const root = this.querySelector('[data-gallery-mobile]');
        if (!currentEl || !root) return;

        const slides = root.querySelectorAll('.splide__slide');
        const total = slides.length;
        const current = Math.min(Math.max(index + 1, 1), total || 1);

        currentEl.textContent = current;
        if (totalEl) totalEl.textContent = total || 1;
      }

      disconnectedCallback() {
        this._mobileMql.removeEventListener('change', this._onMobileMqlChange);
        this._destroyMobileSplide();
      }

      _bindMobileSplide() {
        if (!this._mobileMql.matches) return;
        if (this._mobileSplide) return;

        const root = this.querySelector('[data-gallery-mobile]');
        if (!root || typeof Splide === 'undefined') return;
        if (root.dataset.singleSlide === 'true') {
          this._updateMobileCounter(0);
          return;
        }

        this._mobileSplide = new Splide(root, {
          type: 'slide',
          rewind: true,
          perPage: 1,
          perMove: 1,
          gap: 0,
          padding: 0,
          arrows: false,
          pagination: false,
          drag: true,
          speed: 400,
          easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
          flickPower: 400,
          focus: 0,
          trimSpace: false,
        });

        this._mobileSplide.on('move', (index) => {
          this._setActiveSlideState(index);
          this._updateMobileCounter(index);
        });
        this._mobileSplide.mount();
        this._setActiveSlideState(this._mobileSplide.index);
        this._updateMobileCounter(this._mobileSplide.index);
      }

      _destroyMobileSplide() {
        if (!this._mobileSplide) return;
        this._mobileSplide.destroy(true);
        this._mobileSplide = null;
      }

      _syncMobileSplide() {
        if (this._mobileMql.matches) {
          this._bindMobileSplide();
        } else {
          this._destroyMobileSplide();
        }
      }

      _setActiveSlideState(index) {
        const root = this.querySelector('[data-gallery-mobile]');
        if (!root) return;

        root.querySelectorAll('.splide__slide').forEach((slide, i) => {
          slide.classList.toggle('is-active', i === index);
        });

        const slide = root.querySelectorAll('.splide__slide')[index];
        if (!slide) return;

        if (typeof window.pauseAllMedia === 'function') {
          window.pauseAllMedia();
        }

        const deferred = slide.querySelector('deferred-media');
        if (deferred && typeof deferred.loadContent === 'function') {
          deferred.loadContent(false);
        }
        const model = slide.querySelector('product-model');
        if (model && typeof model.loadContent === 'function') {
          model.loadContent();
        }
      }

      _goToMobileSlide(mediaId, prepend) {
        const root = this.querySelector('[data-gallery-mobile]');
        if (!root) return;

        const slide = root.querySelector(`.splide__slide[data-media-id="${mediaId}"]`);
        if (!slide) return;

        const list = root.querySelector('.splide__list');
        if (prepend && list && slide !== list.firstElementChild) {
          list.prepend(slide);
          if (this._mobileSplide) {
            this._mobileSplide.refresh();
            this._mobileSplide.go(0);
            this._updateMobileCounter(0);
          }
        } else if (this._mobileSplide) {
          const slides = Array.from(root.querySelectorAll('.splide__slide'));
          const index = slides.indexOf(slide);
          if (index >= 0) this._mobileSplide.go(index);
        }

        root.querySelectorAll('[data-media-id]').forEach((el) => el.classList.remove('is-active'));
        slide.classList.add('is-active');
        const index = this._mobileSplide ? this._mobileSplide.index : 0;
        this._setActiveSlideState(index);
        this._updateMobileCounter(index);
      }

      setActiveMedia(mediaId, prepend) {
        if (this._mobileMql.matches) {
          this._goToMobileSlide(mediaId, prepend);
          return;
        }

        const wrap = this.querySelector('[data-gallery-viewer]');
        if (!wrap) return;

        const target = wrap.querySelector(`[data-media-id="${mediaId}"]`);
        if (!target) return;

        if (prepend) {
          const hero = wrap.querySelector('.product-gallery__cell--hero');
          if (hero && target !== hero) {
            target.classList.remove('product-gallery__cell--grid');
            target.classList.add('product-gallery__cell--hero');
            hero.classList.remove('product-gallery__cell--hero');
            hero.classList.add('product-gallery__cell--grid');
            wrap.insertBefore(target, wrap.firstElementChild);
          } else if (!hero) {
            wrap.prepend(target);
            target.classList.add('product-gallery__cell--hero');
            target.classList.remove('product-gallery__cell--grid');
          }
        }

        wrap.querySelectorAll('[data-media-id]').forEach((el) => {
          el.classList.remove('is-active');
        });
        target.classList.add('is-active');

        if (typeof window.pauseAllMedia === 'function') {
          window.pauseAllMedia();
        }

        const deferred = target.querySelector('deferred-media');
        if (deferred && typeof deferred.loadContent === 'function') {
          deferred.loadContent(false);
        }
        const model = target.querySelector('product-model');
        if (model && typeof model.loadContent === 'function') {
          model.loadContent();
        }
      }
    }
  );
}
